import { memo } from 'react';

import NextSvg from '@/shared/assets/icons/ui-kit/pagination-next-arrow.svg';
import PrevSvg from '@/shared/assets/icons/ui-kit/pagination-prev-arrow.svg';
import { useMatchMedia } from '@/shared/lib/hooks/use-match-media.hook';

import * as Styled from './pagination.styles';
import { TanstackPaginationProps } from './pagination.types';

const TanstackPaginationComponent = ({
	onChangePage,
	page,
	className,
	totalPages,
	pagesCutCount = 5,
	hasRowsPerPage = false,
}: TanstackPaginationProps) => {
	const isMobile = useMatchMedia('mobile');

	const isFirstPage = page === 1;
	const isLastPage = page === totalPages;
	const visiblePagesCount = isMobile ? Math.min(pagesCutCount, 2) : pagesCutCount;

	const startPage = Math.max(1, page - Math.floor(visiblePagesCount / 2));
	const endPage = Math.min(totalPages, startPage + visiblePagesCount - 1);

	const visiblePages = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);

	return (
		<Styled.Wrapper className={className} hasRowsPerPage={hasRowsPerPage}>
			<Styled.Arrow Svg={PrevSvg} disabled={isFirstPage} onClick={() => !isFirstPage && onChangePage(page - 1)} />
			{visiblePages.map((p) => (
				<Styled.Number key={p} active={p === page} onClick={() => onChangePage(p)}>
					{p}
				</Styled.Number>
			))}
			<Styled.Arrow Svg={NextSvg} disabled={isLastPage} onClick={() => !isLastPage && onChangePage(page + 1)} />
		</Styled.Wrapper>
	);
};

export default memo(TanstackPaginationComponent);
